// Magyarország
export default {
	title: "Vip Szint",
	current: "Jelenlegi VIP Szint",
	status: {
		btn: ["Aktivált", "Regisztráció"]
	}
};
